const rawEscape = (data) => {
    return data
        .replace(/\\/g, '\\\\')
        .replace(/"/g, '\\"')
        .replace(/\t/g, '\\t')
        .replace(/(\r\n|\n|\r)/g, '\\n')
}

const rawUnescape = (data) => {
    return data
        .replace(/\\(\\|"|t|n)/g, (match, escaped) => {
            switch (escaped) {
                case '\\': return '\\'
                case '"': return '"'
                case 't': return '\t'
                case 'n': return '\n'
                default: return match
            }
        })
}

// Detects data that is already valid escaped-JSON string content, so
// EscapeJson can leave it as-is instead of escaping it a second time.
// Note: this is inherently a best-effort guess. A raw two-character
// sequence like backslash+n is indistinguishable from an already-escaped
// newline, so genuinely raw text containing literal \, \t, \n or \" can be
// misdetected as "already escaped" and left un-escaped. See ToolsCommon.test.js.
const isAlreadyEscaped = (data) => {
    try {
        JSON.parse(`"${data}"`)
        return true
    } catch (e) {
        return false
    }
}

module.exports.EscapeJson = (data) => (isAlreadyEscaped(data) ? data : rawEscape(data))

module.exports.UnescapeJson = rawUnescape
